import React from 'react';
import PropTypes from 'prop-types';
import getDayName from 'services/getDayName';
import './index.scss';

/*
 * Types definition
 */
const propTypes = {
    tradingHours: PropTypes.shape({
        monday: PropTypes.string,
        tuesday: PropTypes.string,
        wednesday: PropTypes.string,
        thursday: PropTypes.string,
        friday: PropTypes.string,
        saturday: PropTypes.string,
        sunday: PropTypes.string,
    }).isRequired,
};

/*
 * Component
 */
function TradingHours({ tradingHours }) {
    return (
        <ul className="trading-hours">
            {tradingHours && Object.keys(tradingHours).map((day) => {
                const hours = tradingHours[day];
                if (!hours) {
                    return null;
                }

                let dayName = day.substring(0, 3);
                let hoursClass = 'hours';

                if (day === getDayName().toLowerCase()) {
                    dayName = 'Today';
                    hoursClass += ' today';
                }

                return (
                    <li key={day}>
                        <span className="day">{dayName}</span>
                        <span className={hoursClass}>{tradingHours[day]}</span>
                    </li>
                );
            })}
        </ul>
    );
}

TradingHours.propTypes = propTypes;

export default TradingHours;
